export default __webpack_public_path__ + "static/media/oncocare-cun.07dd33fd.jpg";